import { useQuery } from '@tanstack/react-query';
import { absencesGet } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useAbsences = (publisherId?: number) =>
  useQuery({
    queryFn: () =>
      extractData(absencesGet({ path: { publisherId: publisherId! } })),
    queryKey: ['absences', publisherId],
    enabled: Boolean(publisherId),
  });
